// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ip-0";
export var fileCarousel = "_ip-2";
export var removeFileButton = "_ip-1";